import request from '@/utils/request'

export const login = params =>
  request({
    url: '/manage/login/index',
    method: 'post',
    data: params
  })

export const logout = params =>
  request({
    url: '/manage/login/logout',
    method: 'post',
    data: params
  })

export const serviceList = params =>
  request({
    url: '/manage/article/index',
    method: 'post',
    data: params
  })

export const serviceEdit = params =>
  request({
    url: '/manage/article/edit',
    method: 'post',
    data: params
  })

export const exportExcel1 = params =>
  request({
    url: '/manage/article/derive',
    // responseType: 'blob', //  配置数据类型
    method: 'post',
    data: params
  })

// 服务列表删除
export const serviceDel = params =>
  request({
    url: '/manage/article/del',
    method: 'post',
    data: params
  })

export const userAdd = params =>
  request({
    url: '/manage/manage/add',
    method: 'post',
    data: params
  })

export const userList = params =>
  request({
    url: '/manage/manage/index',
    method: 'post',
    data: params
  })

// 用户删除
export const userDel = params =>
  request({
    url: '/manage/manage/del',
    method: 'post',
    data: params
  })

// 用户编辑
export const userEdit = params =>
  request({
    url: '/manage/manage/edit',
    method: 'post',
    data: params
  })

// 图片上传
export const uploadImgs = params =>
  request({
    url: '/api/file/upload',
    method: 'post',
    noToken: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: params
  })

export const fetchNurseList = params =>
  request({
    url: '/manage/nurses/index',
    method: 'post',
    data: params
  })
export const fetchHospitalList = params =>
  request({
    url: '/manage/orders/hospital_lists',
    method: 'post',
    data: params
  })
export const fetchFosterList = params =>
  request({
    url: '/manage/orders/dis_lists',
    method: 'post',
    data: params
  })

export const fetchFosterRecordList = params =>
  request({
    url: '/manage/orders/dis_record_lists',
    method: 'post',
    data: params
  })
export const fetchNurseServices = params =>
  request({
    url: '/api/nurse_services/item',
    method: 'post',
    data: params
  })

export const fetchOrderList = params =>
  request({
    url: '/manage/orders/lists',
    method: 'post',
    data: params
  })
export const fetchOrderDetailById = params =>
  request({
    url: '/manage/orders/detail',
    method: 'post',
    data: params
  })
export const delOrderById = params =>
  request({
    url: '/manage/orders/delete',
    method: 'post',
    data: params
  })

export const delOrderServiceById = params =>
  request({
    url: '/manage/orders/delete_record',
    method: 'post',
    data: params
  })

export const editOrderUserInfoById = params =>
  request({
    url: '/manage/orders/edit_userinfo',
    method: 'post',
    data: params
  })

export const allocateOrderInfoById = params =>
  request({
    url: '/manage/orders/allocate',
    method: 'post',
    data: params
  })

export const cancelOrderById = params =>
  request({
    url: '/manage/orders/cancel',
    method: 'post',
    data: params
  })
export const auditOrderCancelById = params =>
  request({
    url: '/manage/orders/verify_refund',
    method: 'post',
    data: params
  })

export const fetchFinancialList = params =>
  request({
    url: '/manage/statistics/cash_flow',
    method: 'post',
    data: params
  })

export const addNurse = params =>
  request({
    url: '/manage/nurses/add',
    method: 'post',
    data: params
  })

export const editNurse = params =>
  request({
    url: '/manage/nurses/edit',
    method: 'post',
    data: params
  })

export const fetchNurseAddressList = params =>
  request({
    url: '/manage/nurses/address',
    method: 'post',
    data: params
  })

export const fetchNurseSList = params =>
  request({
    url: '/manage/nurses/lists',
    method: 'post',
    data: params
  })
export const fetchCouponList = params =>
  request({
    url: '/manage/coupon',
    method: 'post',
    data: params
  })

export const addCoupon = params =>
  request({
    url: '/manage/coupon/add',
    method: 'post',
    data: params
  })

export const fetchCouponDetail = params =>
  request({
    url: '/manage/coupon/info',
    method: 'post',
    data: params
  })

export const sendCoupon = params =>
  request({
    url: '/manage/coupon/send',
    method: 'post',
    data: params
  })

export const fetchStatisticsOrderQuantity = params =>
  request({
    url: '/manage/statistics/order_quantity',
    method: 'post',
    data: params
  })

export const fetchStatisticsOrderYmw = params =>
  request({
    url: '/manage/statistics/order_ymw',
    method: 'post',
    data: params
  })
export const fetchStatisticsOrderCancel = params =>
  request({
    url: '/manage/statistics/order_cancel',
    method: 'post',
    data: params
  })

export const fetchStatisticsOrderPieChart = params =>
  request({
    url: '/manage/statistics/order_pie_chart',
    method: 'post',
    data: params
  })

export const fetchRolesList = params =>
  request({
    url: '/manage/manage/roles',
    method: 'post',
    data: params
  })

export const editUsrRoles = params =>
  request({
    url: '/manage/manage/edit',
    method: 'post',
    data: params
  })

export const fetchHospitalManageList = params =>
  request({
    url: '/manage/hospital/lists',
    method: 'post',
    data: params
  })

export const fetchOrderNoticeList = params =>
  request({
    url: '/manage/notices/lists',
    method: 'post',
    data: params
  })

export const getOrderNoticeUrl = params =>
  request({
    url: '/manage/notices/add',
    method: 'post',
    data: params
  })
export const delOrderNotice = params =>
  request({
    url: '/manage/notices/del',
    method: 'post',
    data: params
  })

export const editHospital = params =>
  request({
    url: '/manage/hospital/edit',
    method: 'post',
    data: params
  })

export const fetchNurseServicesList = params =>
  request({
    url: '/api/nurse_services/index',
    method: 'post',
    data: params
  })

export const insertHospital = params =>
  request({
    url: '/manage/hospital/add',
    method: 'post',
    data: params
  })

export const fetchHospitalPList = params =>
  request({
    url: '/wx/hospital/lists',
    method: 'post',
    data: params
  })

export const insertOrder = params =>
  request({
    url: '/manage/orders/create',
    method: 'post',
    data: params
  })

export const updateOrder = params =>
  request({
    url: '/manage/orders/edit',
    method: 'post',
    data: params
  })
